import { render, staticRenderFns } from "./price.tab.vue?vue&type=template&id=6fa1a4f8&scoped=true"
import script from "./price.tab.vue?vue&type=script&lang=js"
export * from "./price.tab.vue?vue&type=script&lang=js"
import style0 from "./price.tab.vue?vue&type=style&index=0&id=6fa1a4f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa1a4f8",
  null
  
)

export default component.exports